var res = [{"Film":"La La Land","Nominierungen":"14","Oscars":"6"},{"Film":"Moonlight","Nominierungen":" 8","Oscars":" 3"},{"Film":"Manchester by the Sea","Nominierungen":" 6","Oscars":" 2"},{"Film":"Arrival","Nominierungen":" 8","Oscars":" 2"},{"Film":""},{"Film":""}];res.columns = ["Film","Nominierungen","Oscars","Metadata"];module.exports = res;


//////////////////
// WEBPACK FOOTER
// ./src/components/main/most-awarded-films.csv
// module id = 96
// module chunks = 0